import type { ContentHref, WebSite, WebSiteHref } from '@generalTypes/apiTypes';
import { selectRawWebPage, selectWebPage } from '@newStore/documentApi/documentApiSelectors';
import { selectWebSites } from '@newStore/externalData/externalDataSelectors';
import { createTypedSelector } from '@newStore/genericHelpers';
import {
  type AsideChangeMessageSelector,
  type WebTabComponent,
  isWebTabComponent,
} from '@nodeTypeConfig/configTypes';
import { getDiffForArraysOfStrings } from '../../../../store/documentUI/transformProposal/asideDiffText';

export const getOldUrl = (
  value: {
    path: string;
    website: {
      href: WebSiteHref;
    };
  },
  webSites: Record<string, WebSite>,
) => `https://${webSites[value.website.href].domain}${value.path}`;

export const selectChangeMessageForAsideWebOldUrls: AsideChangeMessageSelector<WebTabComponent> =
  createTypedSelector(
    [
      (state, href: ContentHref) => selectWebPage(state, href),
      (state, href: ContentHref) => selectRawWebPage(state, href),
      (state) => selectWebSites(state),
      (state, href: ContentHref, config: WebTabComponent) => config,
    ],
    (content, originalContent, webSites, config): string | null => {
      if (!isWebTabComponent(config)) {
        console.error('Edit config is not for webPage', config);
      }

      if (!config.property) {
        console.error('No property found for config', config);
        throw Error(`Can not convert ${config} property to a string`);
      }

      const newValue: string[] = content?.oldLocations?.map((v) => getOldUrl(v, webSites)) ?? [];
      const oldValue: string[] =
        originalContent?.oldLocations?.map((v) => getOldUrl(v, webSites)) ?? [];

      return getDiffForArraysOfStrings(oldValue, newValue);
    },
  );
